module.exports = __webpack_public_path__ + "img/straight_curve_line_icon.52f1a03e.svg";